var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14118_67985)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28518 24.0183H27.9012C27.9012 23.3596 27.4027 23.1472 27.0924 22.7663C26.763 22.362 26.5173 22.0074 26.3326 21.448C25.884 20.0893 26.0552 19.1147 26.0552 17.5293C26.0552 15.9497 26.1977 14.5719 25.9956 13.0566C25.8982 12.3263 25.7311 11.8122 25.5227 11.1792C25.404 10.8184 24.9924 9.76253 24.8033 9.57825C24.3709 8.44042 22.6033 6.63167 21.4994 5.93604C21.3262 5.82694 21.251 5.75649 21.0692 5.65731C20.8758 5.55185 20.8009 5.51455 20.6178 5.40051C19.8953 4.95066 19.0065 4.77914 18.7396 4.63799L18.6507 4.58027C18.64 4.57351 18.6202 4.5609 18.6075 4.54804C18.2939 4.65887 17.5645 4.41902 16.915 4.36759L16.4567 4.30421C16.4415 4.29974 16.4126 4.30511 16.4017 4.28111C16.3909 4.25707 16.3644 4.26663 16.3476 4.25586C15.9802 4.29588 16.2061 4.29588 15.8387 4.25586C15.7652 4.30145 15.8635 4.27234 15.6749 4.32242L15.2373 4.36485C14.5727 4.41011 13.9407 4.68228 13.5788 4.55133C13.3816 4.76021 13.0662 4.75295 12.5959 4.94976C12.3888 5.03642 12.274 5.09263 12.1046 5.16535C10.5539 5.83106 8.98336 7.29238 8.00257 8.7503L7.58894 9.3794C7.46907 9.60107 7.48389 9.42424 7.53122 9.64396C6.99581 9.99131 6.31974 12.6021 6.24005 13.1075C5.92864 15.0815 6.13114 15.7039 6.13114 17.5293C6.13114 19.064 6.29356 20.0994 5.86958 21.3986C5.67422 21.9972 5.47572 22.2768 5.12228 22.7298C4.81674 23.1215 4.28518 23.3474 4.28518 24.0183Z",
    fill: "url(#paint0_linear_14118_67985)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3247 28.8009H18.8627C19.2561 28.8733 27.0393 28.8869 27.3407 28.7777C27.8086 28.608 27.9071 28.2357 27.9025 27.5835C27.8943 26.3962 27.9017 25.2061 27.9017 24.0186H4.28567C4.28567 25.1843 4.29183 26.3518 4.28524 27.5173C4.27625 29.1103 4.98373 28.8311 6.44994 28.8311C7.47715 28.8311 12.7816 28.9008 13.3247 28.8009Z",
    fill: "#4EDAA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8622 28.8008H13.3242C13.3242 30.046 13.3447 30.8139 13.9148 31.5067C14.4249 32.1267 15.0685 32.4845 15.7352 32.5763H16.4292C17.0813 32.4865 17.7194 32.1429 18.2417 31.5415C18.8369 30.8564 18.8622 30.0659 18.8622 28.8008L18.8622 28.8008Z",
    fill: "#2E8C5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5796 4.55135C13.9415 4.6823 14.5736 4.41015 15.2382 4.36487L15.6757 4.32244C15.8643 4.27235 15.766 4.30148 15.8396 4.25587C15.4746 4.10239 15.18 3.86335 15.2317 3.27273C15.3237 2.22143 16.8196 2.26063 16.9498 3.21165C17.0359 3.83991 16.7244 4.0977 16.3484 4.25585C16.3652 4.26662 16.3917 4.25706 16.4026 4.2811C16.4134 4.3051 16.4423 4.29975 16.4576 4.3042L16.9158 4.36759C17.5653 4.41901 18.2948 4.65887 18.6083 4.54803C18.6443 4.43086 18.663 4.42702 18.7064 4.294C19.3299 2.38129 17.9658 0.77678 16.3892 0.576172H15.7337C15.0518 0.663291 14.3755 1.03158 13.8418 1.76679C13.1487 2.72145 13.2779 3.53676 13.5795 4.5513L13.5796 4.55135Z",
    fill: "#B2E6CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0547 7.14679C26.0547 7.77323 26.4986 8.06671 27.1369 8.06671C27.5968 8.06671 28.2911 7.1709 28.585 6.86753C28.9093 6.53277 29.7467 5.86122 29.7467 5.30696C29.7467 4.49356 28.8486 3.82116 27.916 4.79713L26.5477 6.21014C26.3076 6.45486 26.0547 6.67941 26.0547 7.14679H26.0547Z",
    fill: "#B2E6CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43945 5.17559C2.43945 5.85977 2.9786 6.22496 3.56934 6.83473C4.26502 7.55287 4.55255 8.06676 5.24028 8.06676C5.88908 8.06676 6.63579 7.22552 5.67053 6.24278L4.30168 4.83034C3.22954 3.70948 2.43947 4.69317 2.43947 5.17559H2.43945Z",
    fill: "#B2E6CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9023 10.7606C27.9023 12.1137 29.0091 11.8777 30.4485 11.8777C31.1704 11.8777 31.5265 11.4896 31.5943 11.0578V10.7438C31.527 10.3051 31.1821 9.90644 30.6395 9.90644C29.6268 9.90644 27.9023 9.64067 27.9023 10.7606Z",
    fill: "#B2E6CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.59375 10.7606C0.59375 12.1137 1.70049 11.8777 3.13995 11.8777C4.76683 11.8777 4.5376 9.90644 3.3309 9.90644C2.31817 9.90644 0.59375 9.64067 0.59375 10.7606H0.59375Z",
    fill: "#B2E6CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14118_67985",
    x1: 16.0933,
    y1: 5.67082,
    x2: 16.5032,
    y2: 29.6225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D458A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AA64C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14118_67985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    fill: "white",
    transform: "translate(0.59375 0.576172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNot);
export default __webpack_public_path__ + "static/media/not.e57100364d12816e036181bc7b45c3c0.svg";
export { ForwardRef as ReactComponent };